import React from 'react'
import { IContentLoaderProps } from 'react-content-loader'
import ContentLoader from './ContentLoader'

export interface Props {
	className?: string
	style?: Record<string, unknown>
	contentLoaderProps?: IContentLoaderProps
}

const ImagePlaceholder: React.FC<Props> = ({ contentLoaderProps, style, ...rest }): JSX.Element => {
	const containerStyles = {
		backgroundColor: 'var(--background-color)',
		...style,
	}

	// `contentLoaderProps` is for the loader, not the container — spreading the whole prop bag onto
	// the div hands React an object it tries to serialise as an attribute.
	return (
		<div {...rest} style={containerStyles}>
			<ContentLoader {...contentLoaderProps}>
				<rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
			</ContentLoader>
		</div>
	)
}

export default ImagePlaceholder
